import {Component, OnInit} from '@angular/core';
import {AppComponent} from 'src/app/app.component';
import {Proposta} from 'src/app/core/viewModel/proposta.model';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {CategoriaPlanoService} from '../../core/services/categoria_plano.service';
import {PropostaService} from '../../core/services/proposta.service';

@Component({
  selector: 'app-tabela-diarias',
  templateUrl: './tabela-diarias.component.html'
})
export class TabelaDiariasComponent implements OnInit {

  constructor(
    private categoriaPlanoService: CategoriaPlanoService,
    private appComponent: AppComponent,
    private propostaService: PropostaService,
    private toast: ToastrService,
    private router: Router) { }

  static COUNT_DIARIAS_DEFAULT = 7;
  static COUNT_PESSOAS_DEFAULT = 2;
  static COUNT_QUARTOS_DEFAULT = 1;

  valoresPlanoList: any = [];

  public planoSelecionado = 'TRANQUILIDADE';
  public qtdPessoaSelecionado = 'DUPLO';
  public propostaResult: Proposta;
  public countDiarias: number = TabelaDiariasComponent.COUNT_DIARIAS_DEFAULT;
  public countPessoas: number = TabelaDiariasComponent.COUNT_PESSOAS_DEFAULT;
  public countQuartos: number = TabelaDiariasComponent.COUNT_QUARTOS_DEFAULT;
  public isConforto = false;

  ngOnInit() {
    this.buscaValoresPlano();
  }

  async buscaValoresPlano() {

    this.appComponent.showOverlay();

    const result = await this.categoriaPlanoService.buscar(this.planoSelecionado, this.qtdPessoaSelecionado);
    this.valoresPlanoList = result.data;

    this.appComponent.hideOverlay();
  }

  configuraValoresProposta() {
    localStorage.setItem('mtl.proposta', JSON.stringify(this.propostaResult));
  }

  async calculaValores() {
    const info = {
      cupom: '',
      listaTitulos: [
        {
          categoriaTitulo: this.isConforto ? 'CONFORTO' : 'TRANQUILIDADE',
          diarias: this.countDiarias,
          pessoas: this.countPessoas,
          quartos: this.countQuartos
        },
      ]
    };

    const result = await this.propostaService.calculaValores(info);
    if (result && result.error) {
      this.toast.error(result.error.description, '', {
        timeOut: 5000
      });
    } else {
      if (result && !result.data.msgError) {
        this.propostaResult = result.data;
      }
    }
  }

  async persistirProposta() {

    if (this.qtdPessoaSelecionado === 'DUPLO') {
      this.countPessoas = 2;
    } else {
      this.countPessoas = 3;
    }

    this.isConforto = this.planoSelecionado === 'CONFORTO';

    await this.calculaValores();

    localStorage.setItem('mtl.proposta', JSON.stringify(this.propostaResult));
    await this.router.navigate(['faca-parte']);
  }
}
